import React, { useState, useRef, useCallback, useEffect } from 'react';
import useVideoStore from './stores/useVideoStore';
import { searchTags } from './api';
import { useTranslations } from '../ArticleFormNew/contexts/TranslationContext';

export default function VideoCategoriesSelect({ scheduleAutosave }) {
  var t = useTranslations();
  var categoryList = useVideoStore(function(s) { return s.category_list; });
  var updateField = useVideoStore(function(s) { return s.updateField; });

  var queryState = useState('');
  var query = queryState[0];
  var setQuery = queryState[1];

  var suggestionsState = useState([]);
  var suggestions = suggestionsState[0];
  var setSuggestions = suggestionsState[1];

  var openState = useState(false);
  var isOpen = openState[0];
  var setIsOpen = openState[1];

  var debounceRef = useRef(null);
  var containerRef = useRef(null);

  var performSearch = useCallback(function(searchQuery) {
    searchTags(searchQuery || '', 'categories')
      .then(function(names) {
        var filtered = names.filter(function(name) { return !categoryList.includes(name); });
        setSuggestions(filtered);
        setIsOpen(filtered.length > 0);
      })
      .catch(function() {
        setSuggestions([]);
      });
  }, [categoryList]);

  var handleInputChange = useCallback(function(e) {
    var value = e.target.value;
    setQuery(value);
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(function() { performSearch(value); }, 300);
  }, [performSearch]);

  var handleFocus = useCallback(function() {
    if (suggestions.length === 0 && !query) {
      performSearch('');
    } else if (suggestions.length > 0) {
      setIsOpen(true);
    }
  }, [suggestions, query, performSearch]);

  var addCategory = useCallback(function(catName) {
    var name = catName.trim();
    if (!name || categoryList.includes(name)) return;
    updateField('category_list', categoryList.concat([name]));
    setQuery('');
    setSuggestions([]);
    setIsOpen(false);
    scheduleAutosave();
  }, [categoryList, updateField, scheduleAutosave]);

  var removeCategory = useCallback(function(catName) {
    updateField('category_list', categoryList.filter(function(c) { return c !== catName; }));
    scheduleAutosave();
  }, [categoryList, updateField, scheduleAutosave]);

  var handleKeyDown = useCallback(function(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      addCategory(query);
    }
  }, [query, addCategory]);

  useEffect(function() {
    function handleClickOutside(e) {
      if (containerRef.current && !containerRef.current.contains(e.target)) { setIsOpen(false); }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return function() { document.removeEventListener('mousedown', handleClickOutside); };
  }, []);

  useEffect(function() {
    return function() { if (debounceRef.current) clearTimeout(debounceRef.current); };
  }, []);

  return (
    <div className="categories-select" ref={containerRef}>
      {categoryList.length > 0 && (
        <div className="categories-select__tags">
          {categoryList.map(function(cat) {
            return (
              <span key={cat} className="categories-select__tag">
                {cat}
                <button type="button" className="categories-select__tag-remove" onClick={function() { removeCategory(cat); }}><i className="zmdi zmdi-close" /></button>
              </span>
            );
          })}
        </div>
      )}
      <div className="form-group">
        <input type="text" className="form-control" placeholder={t.type_enter} value={query} onChange={handleInputChange} onKeyDown={handleKeyDown} onFocus={handleFocus} autoComplete="off" />
        <i className="form-group__bar" />
      </div>
      {isOpen && suggestions.length > 0 && (
        <div className="categories-select__suggestions">
          {suggestions.map(function(name, i) {
            return (<div key={name + i} className="categories-select__suggestion-item" onClick={function() { addCategory(name); }}>{name}</div>);
          })}
        </div>
      )}
    </div>
  );
}
